import QRCode from "qrcode";

export default {
  qrcode(id, url, append = false) {
    let $doc = document.getElementById(id);

    if (append) {
      QRCode.toCanvas(
        url, {
          errorCorrectionLevel: "H"
        },
        function (err, canvas) {
          if (err) throw err;
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          $doc.appendChild(canvas);
        }
      );
    } else {
      QRCode.toCanvas($doc, url, {
        errorCorrectionLevel: "H"
      });
      $doc.style.width = "100%";
      $doc.style.height = "100%";
    }
    return $doc;
  },
  qrcodeCanvas(doc, url) {
    QRCode.toCanvas(doc, url, {
      errorCorrectionLevel: "H"
    });
    doc.style.width = "100%";
    doc.style.height = "100%";
    return doc;
  }
};



// WEBPACK FOOTER //
// ./src/utils/core.js